import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod/v4-mini"
import {imageOpHalOptions} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal-types"

export const grayscaleConversionMode = z.union([z.literal("luminance"), z.literal("average")])

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            imageOpHalOptions: imageOpHalOptions,

            sourceImage: anyImageOpResult,
            mode: grayscaleConversionMode,
        }),
    },
}
